import { render, staticRenderFns } from "./LeewayTable.vue?vue&type=template&id=706133c4&"
import script from "./LeewayTable.vue?vue&type=script&lang=js&"
export * from "./LeewayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports